import * as React from 'react'
import {FC, Fragment} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../lib/MobXProvider'
import {WidgetApi} from '../../lib/WidgetApi'
import {SlotComponentConfig} from '../../lib/WidgetConfig'
import {DynamicSlotName} from '../../lib/DynamicSlotName'
import {DynamicComponent} from './DynamicComponent'

///////////////////////////////////////////////////////////////////////////////

export type DynamicSlotProps = {
  name: DynamicSlotName
  [key: string]: any
}

///////////////////////////////////////////////////////////////////////////////

export const DynamicSlot: FC<DynamicSlotProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  const {debugSlots} = api.computedConfig
  const {name, ...rest} = props
  const slots = api.computedConfig.slots[name] as SlotComponentConfig[]

  return (
    <Fragment>
      {slots && debugSlots && <div className="slot-marker open">{name}</div>}

      {!slots && debugSlots && <div className="slot-marker empty">{name}</div>}

      {slots && <DynamicComponent slots={slots} {...rest} />}

      {slots && debugSlots && <div className="slot-marker close">{name}</div>}
    </Fragment>
  )
})
